import React from 'react'
import { IconButton, Paragraph, useContainerWidth } from '@fs/zion-ui'
import { css } from '@emotion/core'

const navButtonCss = css`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 16px;
  margin-inline-end: 0;
  margin-bottom: 16px;
  margin-inline-start: 0;
`

export default function NavButton({
  disabled,
  title,
  icon,
  handleOnClick,
  color,
  emphasis,
  iconDirection = 'up',
  size = 'md',
  loading,
  description = '',
}) {
  const atWidth = useContainerWidth()
  return (
    <div css={navButtonCss}>
      <IconButton
        title={title}
        Icon={icon}
        onClick={handleOnClick}
        iconDirection={iconDirection}
        color={color}
        emphasis={emphasis}
        size={size}
        disabled={disabled || loading}
        description={description}
      />
      {size === 'md' &&
        atWidth({
          default: <Paragraph size="sm">{title}</Paragraph>,
          md: <Paragraph>{title}</Paragraph>,
        })}
      {size === 'sm' && <Paragraph size="sm">{title}</Paragraph>}
      {size === 'lg' && <Paragraph size="sm">{title}</Paragraph>}
    </div>
  )
}
